import { useQuery } from '@tanstack/react-query';
import { getLocationPrinters, queryKeys } from '@vgrubs/components';

/**
 * A location's tablet printers as the tablet last reported them, printers in
 * error first. Refreshed when the window regains focus, like any query - the
 * tablet reports over its own socket, which the admin does not listen to.
 */
export const useLocationPrinters = (locationId: number | string) => {
  const query = useQuery({
    queryKey: queryKeys.systemProblems.locationPrinters(locationId),
    queryFn: async () => {
      const { data } = await getLocationPrinters(locationId);
      return data.data;
    },
  });

  return {
    printers: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
